import * as Yup from "yup";

const editWordValidation = Yup.object().shape({
  // userPassword: Yup.string()
  //   .min(8, "کلمه عبور نباید کمتر از 8 کاراکتر باشد")
  //   .max(255, "کلمه عبور نباید بیشتر از 255 کاراکتر باشد"),
  // confirmUserPassword: Yup.string().oneOf(
  //   [Yup.ref("userPassword"), null],
  //   "کلمه عبور و تکرار آن یکسان نمی باشد"
  // ),
});

export { editWordValidation };
